export default __webpack_public_path__ + "terms-and-conditions.pdf";